module.exports = __webpack_public_path__ + "img/silence_ca_pousse.9b4fa7ac.jpg";